import React from 'react'
import { motion } from 'framer-motion'
import HomeBanner from '../components/HomeBanner'
import "./Home.css"
import PrincipalMessage from '../components/PrincipalMessage';
import HomeCards from '../components/HomeCards';
// import Stats from '../components/Stats';
import {
  FaGraduationCap,
  FaBookOpen,
  FaUserGraduate,
  FaUniversity
} from "react-icons/fa";
import HomeGallery from '../components/HomeGallery';
import HomeAbout from '../components/HomeAbout';
import HomeCourses from '../components/HomeCourses';
import Updates from '../components/Updates';

// Reusable animation config
const fadeUpVariant = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
};

const Home = () => {


  return (
    <div>
        <HomeBanner/>

    <motion.section
      className="notice"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeUpVariant}
    >

      {/* LEFT SIDE */}
      <div className="notice-label">
        NOTICE
      </div>

      {/* RIGHT SIDE */}
      <div className="notice-marquee">

        <div className="notice-track">
          Admissions Open For 2026 Session | Scholarship Forms Available |
          Annual Function On 25th May | Semester Exams Starting From June |
          New Courses Introduced For Students |
        </div>

      </div>

    </motion.section>
    {/*  */}


   <motion.div
     initial="hidden"
     whileInView="visible"
     viewport={{ once: true, amount: 0.3 }}
     variants={fadeUpVariant}
   >
     <HomeAbout/>
   </motion.div>

   {/*  */}
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeUpVariant}
    >
      <HomeCards
        cardsData={[
          {
            icon: <FaGraduationCap />,
            heading: "Quality Education",
            description:
              "Providing excellence in academics and holistic learning."
          },

          {
            icon: <FaBookOpen />,
            heading: "Modern Library",
            description:
              "Access thousands of books and digital learning resources."
          },

          {
            icon: <FaUserGraduate />,
            heading: "Expert Faculty",
            description:
              "Learn from highly experienced and dedicated educators."
          },

          {
            icon: <FaUniversity />,
            heading: "Campus Facilities",
            description:
              "Modern infrastructure with advanced classrooms and labs."
          }
        ]}
      />
    </motion.div>



    {/* <Stats/> */}

    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeUpVariant}
    >
      <PrincipalMessage/>
    </motion.div>

    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeUpVariant}
    >
      <HomeCourses/>
    </motion.div>

    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeUpVariant}
    >
      <HomeGallery/>
    </motion.div>
 <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeUpVariant}
    >
      <Updates/>
    </motion.div>
    </div>


  )
}

export default Home